'use strict';

exports.generic = require('./generic');
exports.charts = require('./charts');